import { useQuery } from 'react-query';
import axios from 'axios';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

export interface SlackChannelOption {
  id: string;
  name: string;
  isMember: boolean;
}

interface SlackChannelsResponse {
  configured: boolean;
  channels: SlackChannelOption[];
}

// item 403c — the workspace's channels for the link picker. Public by default (private
// channels never appear); item 379 — pass privateChannels for the invite-only accountant
// thread, which lists PRIVATE channels the bot is a member of. Cached 60s server-side;
// mirror that staleTime, keyed by visibility so the two lists don't clobber each other.
const useSlackChannels = (privateChannels = false) => useQuery<SlackChannelsResponse>(
  ['slackChannels', privateChannels],
  async () => {
    const { data } = await axios.get(
      `${apiUrl()}Chat/slack-channels${privateChannels ? '?private=true' : ''}`,
    );
    return data;
  },
  { staleTime: 60_000 },
);

export default useSlackChannels;
